import { inject, Injectable } from '@angular/core';
import { TvLoginStore } from '../../pages/app/services/app.store';
import { hostConfig } from '../common.model';
import { MobileAppsEnum } from '../enums/mobileApps.enum';

declare const webkit: any;
declare const Android: any;
declare global {
  interface Window {
    clearClientNameOnMobile(): void;
  }
}

@Injectable({ providedIn: 'root' })
export class MobileService {
  readonly tvLoginStore = inject(TvLoginStore);
  readonly mobileApp = MobileAppsEnum.trueview; // looks unused

  isMobileApp(): boolean {
    return this.tvLoginStore.getUrlParameterIsMobileApp(); // TODO: move this method to the store
  }

  isMobileDevice(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  isTabletDevice(): boolean {
    const agent = navigator.userAgent;
    return agent.includes('iPad') || (agent.includes('Android') && !agent.includes('Mobile'));
  }

  openExternalUrl(url: string): void {
    try {
      webkit.messageHandlers.externalLinkHandler.postMessage({ link: url });
    } catch (error) {
      console.log('The native context does not exist yet');
    }

    try {
      Android.externalLinkHandler(url);
    } catch (error) {
      console.log('Android context does not exist yet');
    }
  }

  passTerms(terms: string) {
    try {
      webkit.messageHandlers.termsHandler.postMessage({ terms });
    } catch (error) {
      console.error(error);
    }

    try {
      const androidTerms = JSON.stringify({ terms });
      Android.termsHandler(androidTerms);
    } catch (error) {
      console.error(error);
    }
  }

  openInternalApp(languageId: number, isSecondaryProvider = false): void {
    const params = { languageId, isSecondaryProvider };

    try {
      webkit.messageHandlers.loginInternal.postMessage(params);
    } catch (error) {
      console.log('The IOS context does not exist yet', params);
    }

    try {
      Android.loginInternal(JSON.stringify(params));
    } catch (error) {
      console.log('Android context does not exist yet', params);
    }
  }

  passLogin(alias: string | null, email: string | null) {
    if (!this.isMobileApp()) return;

    try {
      webkit.messageHandlers.loginHandler.postMessage({ alias, email });
    } catch (error) {
      console.error(error);
    }

    try {
      const params = JSON.stringify({ alias, email });
      Android.loginHandler(params);
    } catch (error) {
      console.error(error);
    }
  }

  getMobileRedirectUrl(clientName: string): string {
    const url = new URL(this.getMobileRedirectDomain(clientName));
    const lang = this.tvLoginStore.getSelectedLanguageId();
    const appVer = this.tvLoginStore.getUrlParameterAppVer();
    const app = this.mobileApp;
    const email = this.tvLoginStore.email();
    const obj = { lang, appVer, app, email };

    Object.keys(obj)
      .filter((key) => !!obj[key])
      .forEach((key) => {
        url.searchParams.append(key, obj[key]);
      });

    return url.toString();
  }

  getMobileRedirectDomain(clientName: string): string {
    return `${hostConfig.monolithApi}/login/mobile/${clientName}`;
  }

  sendClientNameOnMobile(clientName: string): void {
    console.log('sendClientNameOnMobile', clientName);

    try {
      webkit.messageHandlers.clientNameHandler.postMessage({ clientName });
    } catch (error) {
      console.log('The native context does not exist yet');
    }

    try {
      Android.clientNameHandler(clientName);
    } catch (error) {
      console.log('Android context does not exist yet');
    }
  }
}
